import React, { createContext } from 'react';

export const BarriosContext = createContext();